/* eslint-disable */
import Vue from 'vue';

export default {
  props: {
    renderContent: Function,
    scope: Object,
    prop: String,
    filters: String,
    multiple: Boolean,
  },
  data() {
    return {
      val: {
        value: '',
        label: ''
      }
    };
  },
  created() {
  },
  methods: {
    isChange() {
      // columns key is empty return false
      if (!this.prop) {
        return false;
      }
      const newValue = this.scope.row[this.prop];
      const oldValue = this.val.value;
      return !(String(newValue) === String(oldValue));
    },
    filterData() {
      if (this.filters) {
        const length = this.filters.length;
        const params = this.filters.split('|');
        const type = params.slice(0, 1);
        const arg = params.slice(1, length);
        const vueFilter = Vue.filter(...type); // 挂载到vue上的过滤器
        this.val.value = this.scope.row[this.prop];
        this.val.label = vueFilter(this.scope.row[this.prop], ...arg);
      } else {
        this.val.label = this.scope.row[this.prop];
      }
    }
  },
  render(h) {
    if (this.isChange()) {
      // rerender
      this.filterData();
    }
    return (this.renderContent ? this.renderContent(h, this.scope, this.val || {}) : (
      <span> {this.val.label}</span>));
  }
};
